export const encodeKlaviyoItemId = (id: string, prefix: string = '$custom:::$default:::') =>
    `${prefix}${id.replace(/[^\w]+/g, '-').toUpperCase()}`;
